<template>
	<div class="title">
		<div>
			{{title}}
		</div>
		<!-- <div class="SeeMore" @click="SeeMore" v-if="SeeFlag">
      查看更多
      <img src="@/assets/channel/login/info-red.png" alt="">
    </div> -->
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			title: {
				type: String,
				default: '请给组件传入标题'
			},
			SeeMoreUrlProp: {
				type: String,
				default: ''
			},
			SeeFlag: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				SeeMoreUrl: this.SeeMoreUrlProp
			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			SeeMore() {
				this.$router.push({
					name: this.SeeMoreUrl,
					query: {
						NodeID: "63",
						to: 'homePage'
					}
				})
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.title {
		width: 90%;
		height: 22px;
		// outline: 1px solid seagreen;
		font-size: 16px;
		font-weight: 500;
		color: #16181a;
		line-height: 22px;
		margin: 0 auto;
		position: relative;
		top: 11px;
		left: 5px;
		display: flex;
		justify-content: space-between;

		.SeeMore {
			width: 30%;
			height: 20px;
			font-size: 14px;
			font-weight: 500;
			color: #e65068;
			line-height: 20px;
			text-align: right;
			cursor: pointer;

			img {
				vertical-align: middle;
			}
		}
	}

	.title::after {
		content: "";
		border-top: 6px solid transparent;
		border-right: 1px solid transparent;
		border-bottom: 6px solid transparent;
		border-left: 4px solid #e71d43;
		height: 10px;
		width: 0px;
		position: absolute;
		transform: translate(-10px);
		top: 0;
	}
</style>
